import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor() {}

  notifyError(message: string): void {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: message,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#E95A1A',
    });
  }

  showSuccessAlertAndAction(msg: string, ejecutar: any) {
    Swal.fire({
      title: 'Éxito',
      text: msg,
      icon: 'success',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
    }).then((result) => {
      if (result.isConfirmed) {
        ejecutar();
      }
    });
  }

  showSuccessAlert(msg: string, ejecutar?: any) {
    if (ejecutar) {
      // Ejecutando notificación
      Swal.fire({
        title: 'Éxito',
        text: msg,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
      }).then(() => {
        // Ejecutando notificación
        ejecutar();
      });
    } else {
      // No hay ejecutar
      Swal.fire({
        title: 'Éxito',
        text: msg,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
      });
    }
  }

  showSuccessAlertPersonalizado(
    title: string,
    msg: string,
    accion?: () => void
  ) {
    Swal.fire({
      title: title,
      text: msg,
      icon: 'success',
      showConfirmButton: !!accion,
      confirmButtonText: 'OK',
      timer: accion ? undefined : 1200,
      width: '512px',
      padding: '0px 30px 30px 30px',
      customClass: {
        popup: 'my-swal-popup',
        confirmButton: accion ? 'my-custom-button' : '',
      },
    }).then((result) => {
      if (accion && result.isConfirmed) {
        accion();
      }
    });
  }

  showErrorssAlertPersonalizado(
    title: string,
    msg: string,
    accion?: () => void
  ) {
    Swal.fire({
      title: title,
      text: msg,
      icon: 'error',
      showConfirmButton: !!accion,
      confirmButtonText: 'OK',
      timer: accion ? undefined : 1200,
      width: '512px',
      padding: '0px 30px 30px 30px',
      customClass: {
        popup: 'my-swal-popup',
        confirmButton: accion ? 'my-custom-button' : '',
      },
    }).then((result) => {
      if (accion && result.isConfirmed) {
        accion();
      }
    });
  }

  handleTimer(msg: string) {
    return msg?.length * 25;
  }

  notifyWarning(message: string) {
    Swal.fire({
      icon: 'warning',
      title: 'Advertencia',
      text: message,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#E95A1A',
    });
  }
}
